import { FC } from "react";
import { Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useCollectionDialogStore } from "../CollectionDialog/stores/CollectionDialogStore";
export const CollectionsCreateButton: FC = () => {
  const { openCreateMode } = useCollectionDialogStore();

  return (
    <Button
      data-testid="collections-create-btn"
      variant="contained"
      startIcon={<Add />}
      onClick={openCreateMode}
      sx={{ whiteSpace: "nowrap" }}
    >
      Create Collection
    </Button>
  );
};
